/* eslint-disable max-lines-per-function */
import {defineCustomElement} from 'extensions/ui-utils';
import {html, LitElement} from 'lit';
import stylesheet from './x-mord-item-multisystem.scss?as=stylesheet';

export class ModifyOrderItemMultisystem extends LitElement {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {
			baseSubtotal: {
				attribute: 'base-subtotal',
				type: Number
			},
			code: {
				type: String
			},
			descrip: {
				type: String
			},
			formattedBaseSubtotal: {
				attribute: 'formatted-base-subtotal',
				type: String
			},
			formattedSubtotal: {
				attribute: 'formatted-subtotal',
				type: String
			},
			hidePricing: {
				attribute: 'hide-pricing',
				type: Boolean
			},
			image: {
				type: String
			},
			lineId: {
				attribute: 'line-id',
				type: Number
			},
			name: {
				type: String
			},
			price: {
				type: Number
			},
			quantity: {
				type: Number
			},
			rooms: {
				type: String
			},
			subtotal: {
				type: Number
			}
		};
	}

	constructor () {
		super();

		/**
		 * @type {number}
		 */
		this.baseSubtotal = 0;

		/**
		 * @type {string}
		 */
		this.code = '';

		/**
		 * @type {string}
		 */
		this.descrip = '';

		/**
		 * @type {string}
		 */
		this.formattedBaseSubtotal = '';

		/**
		 * @type {string}
		 */
		this.formattedSubtotal = '';

		/**
		 * @type {boolean}
		 */
		this.hidePricing = false;

		/**
		 * @type {string}
		 */
		this.image = '';

		/**
		 * @type {number}
		 */
		this.lineId = 0;

		/**
		 * @type {string}
		 */
		this.name = '';

		/**
		 * @type {number}
		 */
		this.price = 0;

		/**
		 * @type {number}
		 */
		this.quantity = 0;

		/**
		 * @type {string}
		 */
		this.rooms = '';

		/**
		 * @type {number}
		 */
		this.subtotal = 0;
	}

	render () {
		return html`
			<div class="container">
				<div class="info">
					<div class="image">
						<img src="${this.image}" loading="lazy" class="image-source" />
					</div>
					<div class="info-name">
						<div class="name">${this.descrip ? this.descrip : this.name}</div>
						<div class="code">${this.code}</div>
					</div>
				</div>
				<div class="details">
					<div class="info-name">
						<div class="name">${this.descrip ? this.descrip : this.name}</div>
						<div class="code">${this.code}</div>
					</div>
					<div class="details-left">
						<div class="rooms">${this.rooms}</div>
						<div class="quantity">QTY: ${this.quantity}</div>
					</div>
					<div class="details-right">
						<div class="quantity">QTY: ${this.quantity}</div>
						<div class="pricing">
							${this.hidePricing ? html`<span class="hide-pricing"></span>` : this.formattedSubtotal}
						</div>
					</div>
				</div>
			</div>
		`;
	}
};

defineCustomElement('x-mord-item-multisystem', ModifyOrderItemMultisystem);
